import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import * as _ from "../../../util/lodash";
var ContentCardBody = createComponent({
  displayName: 'ContentCardBody',
  propTypes: {
    onClick: PropTypes.func
  },
  defaultProps: {
    onClick: _.noop
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _contentBodyCx = cx({
      'content-card-body': true,
      'content-card-body--inverted': p.isInverted
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _contentBodyCx,
      ref: p.setBodyRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-body__inner"
    }, p.children));
  }
});
export default ContentCardBody;
//# sourceMappingURL=content-card-body.js.map